module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by Dr. Shelley Viola Murphy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("1. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LABAMA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACK")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMESTEADERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-1"
    }
  }, [_vm._v("Luke Sconiers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-2"
    }
  }, [_vm._v("William Beard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-3"
    }
  }, [_vm._v("Clem Horn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-4"
    }
  }, [_vm._v("Vandy Hutchins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-5"
    }
  }, [_vm._v("Frank Crittenden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-6"
    }
  }, [_vm._v("John Henry Kyles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RKANSAS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACK")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMESTEADERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Levi or Levy Hampton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gideon Murphy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reuben Murphy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don and Minnie-Lee McCormick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irving Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORIDA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACK")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMESTEADERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexander Gainer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simon Bell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Randel Farnell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry McGehee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen McCaskill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUISIANA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACK")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMESTEADERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Baptiste")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter Clark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phoebe Ann Bartlett Franklin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frank Thompson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas Monroe Pittman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wade Pittman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Paysinger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moses Singleton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Henry Veal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Andrew Richardson and Sarah Jane (Foster) Richardson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Williams and Chester Williams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry and Julia Gordon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moses Dyson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moses Brumfield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Labron Brock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Josiah Cyprian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Turner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leander Youngblood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISSISSIPPI")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACK")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMESTEADERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irvin Brumfield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Europe Bates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samuel Brown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prince Dunbar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daner Gibson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("America Hunt Harrell/Harold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter Hunt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jacob Ramsey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William “Willie” or “Boss” Ramsey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Riely (Riley)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Veal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verdal Wills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sailor Allen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edmund Downs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Untold_Stories",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Untold Stories of Black Homesteaders in Florida")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0